import React from 'react';
import './App.css';
import './Videoplayer.css';

const propTypes = {};

class VideoPlayer extends React.Component {
    constructor(props) {
        super(props);

        this.player = null;

        //Initializing reference to error handlers
        this.onErrorEvent = this.onErrorEvent.bind(this);
        this.onError = this.onError.bind(this);
    }

    onErrorEvent(event) {
        // Extract the shaka.util.Error object from the event.
        this.onError(event.detail);
    }

    onError(error) {
        // Log the error.
        console.error('Error code', error.code, 'object', error);
    }

    componentWillMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.endTime !== prevProps.endTime) {
            let self = this;
            self.video.addEventListener('timeupdate', () => {
                if (self.video.currentTime >= self.props.endTime)
                    self.video.pause();
            });
        }
    }


    async componentDidMount() {

        let self = this;

        const loadPlayer = this.loadPlayerScript();
        const loadPlayerUi = loadPlayer.then(() => this.loadPlayerUiScript());

        loadPlayerUi
            .then(() => {
                this.setupPlayer();
                // This runs if the asynchronous load is successful.
                console.log('The video has now been loaded!');
            })
            .catch(() => {});
    }

    loadPlayerScript = () => {
        if (!window.bitmovin) {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = 'https://cdn.bitmovin.com/player/web/8.101.0/bitmovinplayer.js';//this.props.playerScript;
                script.type = 'text/javascript';
                script.id = 'player';
                script.addEventListener('load', () => {
                    resolve();
                });
                script.addEventListener('error', e => {
                    reject(e);
                });

                document.body.appendChild(script);
            });
        }
        return Promise.resolve();
    };

    loadPlayerUiScript = () => {
        if (!window.bitmovin.playerui) {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = 'https://cdn.bitmovin.com/player/web/8.101.0/bitmovinplayer-ui.js';//this.props.playerScript;
                script.type = 'text/javascript';
                script.id = 'playerUi';
                script.addEventListener('load', () => {
                    resolve();
                });
                script.addEventListener('error', e => {
                    reject(e);
                });

                document.body.appendChild(script);
            });
        }
        return Promise.resolve();
    };

    // initialsize or setup player
    async setupPlayer() {

        // Bitmovin Player Config
        let bitmovinPlayerConfig = {
            key: '1c444b9c-fcea-4772-b31c-6baa8fc8da04',
            ui: false,
            playback: {
                muted: false,
                autoplay: true
            }
        }

        this.player = new window.bitmovin.player.Player(
            document.getElementById('vplayer'),
            bitmovinPlayerConfig
        );

        this.addEventListeners();

        let uiManager = new window.bitmovin.playerui.UIManager(this.player, this.createUIContainer());

        await this.player.load(this.props.sourceConfig).then(
            () => {
                console.log('Successfully created Bitmovin Player instance');
                },
            (reason) => {
                console.log('Error while creating Bitmovin Player instance');
            }
        );
    }

    createUIContainer = () => {
        let playerRef = this.player;

        let rewind10sButton = new window.bitmovin.playerui.Button({cssClass: 'ui-rewindbutton bmpui-ui-button'});
        rewind10sButton.onClick.subscribe(function () {
            playerRef.seek(Math.max(0, playerRef.getCurrentTime() - 10));
        });

        let rewind5sButton = new window.bitmovin.playerui.Button({cssClass: 'ui-rewindbutton bmpui-ui-button'});
        rewind5sButton.onClick.subscribe(function () {
            playerRef.seek(Math.max(0, playerRef.getCurrentTime() - 5));
        });

        let forward10sButton = new window.bitmovin.playerui.Button({cssClass: 'ui-forwardbutton bmpui-ui-button'});
        forward10sButton.onClick.subscribe(function () {
            playerRef.seek(Math.min(playerRef.getDuration(), playerRef.getCurrentTime() + 10));
        });

        let forward5sButton = new window.bitmovin.playerui.Button({cssClass: 'ui-forwardbutton bmpui-ui-button'});
        forward5sButton.onClick.subscribe(function () {
            playerRef.seek(Math.min(playerRef.getDuration(), playerRef.getCurrentTime() + 5));
        });

        let subtitleOverlay = new window.bitmovin.playerui.SubtitleOverlay();

        let mainSettingsPanelPage = new window.bitmovin.playerui.SettingsPanelPage({
            components: [
                new window.bitmovin.playerui.SettingsPanelItem('Video Quality', new window.bitmovin.playerui.VideoQualitySelectBox()),
                new window.bitmovin.playerui.SettingsPanelItem('Speed', new window.bitmovin.playerui.PlaybackSpeedSelectBox()),
                new window.bitmovin.playerui.SettingsPanelItem('Audio Quality', new window.bitmovin.playerui.AudioQualitySelectBox()),
            ],
        });

        let settingsPanel = new window.bitmovin.playerui.SettingsPanel({
            components: [
                mainSettingsPanelPage,
            ],
            hidden: true,
        });

        let subtitleSettingsPanelPage = new window.bitmovin.playerui.SubtitleSettingsPanelPage({
            settingsPanel: settingsPanel,
            overlay: subtitleOverlay,
        });

        const subtitleSelectBox = new window.bitmovin.playerui.SubtitleSelectBox();

        let subtitleSettingsOpenButton = new window.bitmovin.playerui.SettingsPanelPageOpenButton({
            targetPage: subtitleSettingsPanelPage,
            container: settingsPanel,
            ariaLabel: 'Subtitles',
            text: 'open',
        });

        mainSettingsPanelPage.addComponent(
            new window.bitmovin.playerui.SettingsPanelItem(
              new window.bitmovin.playerui.SubtitleSettingsLabel({
                text: 'Subtitles',
                opener: subtitleSettingsOpenButton,
              }),
              subtitleSelectBox,
              {
                role: 'menubar',
              },
            ));

        settingsPanel.addComponent(subtitleSettingsPanelPage);

        let controlBar = new window.bitmovin.playerui.ControlBar({
            components: [
                settingsPanel,
                new window.bitmovin.playerui.Container({
                    components: [
                        new window.bitmovin.playerui.PlaybackTimeLabel({
                            timeLabelMode: window.bitmovin.playerui.PlaybackTimeLabelMode.CurrentTime,
                            hideInLivePlayback: true
                        }),
                        new window.bitmovin.playerui.SeekBar({label: new window.bitmovin.playerui.SeekBarLabel()}),
                        new window.bitmovin.playerui.PlaybackTimeLabel({
                            timeLabelMode: window.bitmovin.playerui.PlaybackTimeLabelMode.TotalTime,
                            cssClasses: ['text-right']
                        }),
                    ],
                    cssClasses: ['controlbar-top'],
                }),
                new window.bitmovin.playerui.Container({
                    components: [
                        rewind10sButton,
                        rewind5sButton,
                        new window.bitmovin.playerui.PlaybackToggleButton(),
                        forward5sButton,
                        forward10sButton,
                        new window.bitmovin.playerui.VolumeToggleButton(),
                        new window.bitmovin.playerui.VolumeSlider(),
                        new window.bitmovin.playerui.Spacer(),
                        new window.bitmovin.playerui.PictureInPictureToggleButton(),
                        new window.bitmovin.playerui.AirPlayToggleButton(),
                        new window.bitmovin.playerui.CastToggleButton(),
                        new window.bitmovin.playerui.VRToggleButton(),
                        new window.bitmovin.playerui.SettingsToggleButton({settingsPanel: settingsPanel}),
                        new window.bitmovin.playerui.FullscreenToggleButton(),
                    ],
                    cssClasses: ['controlbar-bottom'],
                }),
            ],
        });

        return new window.bitmovin.playerui.UIContainer({
            components: [
                subtitleOverlay,
                new window.bitmovin.playerui.BufferingOverlay(),
                new window.bitmovin.playerui.PlaybackToggleOverlay(),
                new window.bitmovin.playerui.CastStatusOverlay(),
                controlBar,
                new window.bitmovin.playerui.TitleBar(),
                new window.bitmovin.playerui.RecommendationOverlay(),
                new window.bitmovin.playerui.Watermark(),
                new window.bitmovin.playerui.ErrorMessageOverlay(),
            ]
        });
    };

    // EventListeners of player
    addEventListeners = () => {
        // eslint-disable-next-line no-new
        const playerInstance = window.bitmovin.player.PlayerEvent;
        this.player.on(playerInstance.Ready, this.ready);
        this.player.on('play', this.play);
        const playerSeek = this.player.seek.bind(this.player);
        // overwriting seek of bitmovin player
        this.player.seek = (time, issuer) => {
            let currentTime;
            if (time === 0 && this.player.getCurrentTime() > 0) {
                currentTime = 0.1;
            } else {
                currentTime = time;
            }
            playerSeek(currentTime, issuer);
        };

        // overwriting videoQualities
        this.player.on(playerInstance.Paused, this.paused);
        this.player.on(playerInstance.SourceLoaded, this.loaded);
        this.player.on(playerInstance.Playing, this.playing);

        // ---- Eventlistener to check device orientation for player controlls
        const orientationEvent =
            'onorientationchange' in window ? 'orientationchange' : 'resize';
        window.addEventListener(orientationEvent, this.orientationConfig, false);
    };

    render() {
        return <div id="vplayer" className="vplayer" />;
    }
}

VideoPlayer.propTypes = propTypes;
export default VideoPlayer;